export function getTwitterOauthUrl(oauthToken) {
    const rootUrl = 'https://api.twitter.com/oauth/authenticate';
    const options = {
        oauth_token: oauthToken,
    };
    const qs = new URLSearchParams(options).toString();
    return `${rootUrl}?${qs}`;
}
